import React from 'react';
import classNames from 'classnames';
import Button from '~/components/atoms/button/button';
import Input from '~/components/atoms/input/input';
import validateNumberRangeFilterStateChange from '~/components/organisms/filters/numberRangeFilter/validateNumberRangeFilterStateChange';
import commonFilterStyle from '~/components/styles/commonFilter.module.scss';
import helperStyle from '~/components/styles/helpers.module.scss';
import { NumberFilter_ControlsState, NumberFilter_State } from '~/core/features/filtering/types/numberFilter.type';
import { UpdateFilterControls } from '~/core/useSearchState';
import styles from './numberRangeFilter.module.scss';

export interface NumberRangeFilterValidationResult {
    newMin: number;
    newMax: number;
}

export interface NumberRangeFilterContainerProps {
    filterState: NumberFilter_State;
    filterControls: NumberFilter_ControlsState;
    updateFilterControls: UpdateFilterControls;
}

// TODO: refactore this and slider filter to one component and get rid of duplicate code
const NumberRangeFilter: React.FC<NumberRangeFilterContainerProps> = ({
    filterControls,
    filterState,
    updateFilterControls,
}) => {
    return <div></div>;
    /* const [min, setMin] = React.useState(filterControls.values.originalMin);
    const [max, setMax] = React.useState(filterControls.values.originalMax);

    React.useEffect(() => {
        setMin(filterControls.values.min);
        setMax(filterControls.values.max);
    }, [filterControls]);

    const callUpdate = (changedValue: 'min' | 'max' | 'both') => {
        if (
            (changedValue === 'min' && min === filterControls.values.min) ||
            (changedValue === 'max' && max === filterControls.values.max)
        ) {
            return;
        }
        const { newMax, newMin } = validateNumberRangeFilterStateChange(
            min,
            max,
            filterControls.values.originalMin,
            filterControls.values.originalMax,
            changedValue
        );

        updateFilterControls({
            value: {
                min: newMin,
                max: newMax,
            },
        });
    }; */

    /* return (
        <div
            className={classNames(commonFilterStyle.serpFormCell, styles.integerFilter)}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    callUpdate('both');
                }
            }}
            role="presentation"
        >
            <div className={styles.integerFilterInputs}>
                <div className={styles.integerFilterCell}>
                    <label htmlFor="from" className={helperStyle.visuallyHidden}>
                        Od
                    </label>
                    <Input
                        type="number"
                        id={filterState.identifier + '-min'}
                        value={min}
                        onChange={(e) => {
                            setMin(Number(e.currentTarget.value));
                        }}
                        onBlur={() => callUpdate('min')}
                    />
                    <span>{filterState.configuration.unit}</span>
                </div>
                <i />
                <div className={styles.integerFilterCell}>
                    <label htmlFor="to" className={helperStyle.visuallyHidden}>
                        Do
                    </label>
                    <Input
                        type="number"
                        id={filterState.identifier + '-max'}
                        value={max}
                        onChange={(e) => {
                            setMax(Number(e.currentTarget.value));
                        }}
                        onBlur={() => callUpdate('max')}
                    />
                    <span>{filterState.configuration.unit}</span>
                </div>
            </div>

            <Button onclick={() => callUpdate('both')} link={false}>
                OK
            </Button>
        </div>
    ); */
};

export default NumberRangeFilter;
